import "./App.scss";
import "./styles/callBtn.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import tg from './assets/images/tg.svg'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductDetail from "./pages/ProductDetail";

function App() {
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <div className="App">
      <Navbar />
      <ScrollToTop />
      
      <a target="_blank" href="https://t.me/DAKO8388">
        <div className="telegram-button">
          <h5>Чем могу помочь?</h5>
          <img src={tg} alt="telegram-link" />
        </div>
      </a>
      

      <Routes>
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/detail/:id" element={<ProductDetail />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default App;
